export default function SafetySection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
              <i className="ri-shield-check-line text-2xl"></i>
            </div>
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                Superbuy Sheet Safety Guide
              </h2>
              <p className="text-sm text-foreground-500">Important information for all visitors</p>
            </div>
          </div>

          <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0 mt-0.5">
                <i className="ri-information-line text-sm"></i>
              </div>
              <p>
                We are an <strong className="text-foreground-900">independent educational website</strong>. 
                We are not affiliated with or endorsed by any specific shopping platform or brand.
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0 mt-0.5">
                <i className="ri-shopping-cart-line text-sm"></i>
              </div>
              <p>
                We <strong className="text-foreground-900">do not sell products</strong> directly. 
                All purchases are made on the main platform through your own account.
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0 mt-0.5">
                <i className="ri-bank-card-line text-sm"></i>
              </div>
              <p>
                We <strong className="text-foreground-900">do not process payments</strong> or store any 
                financial information. All transactions are handled securely by the main platform.
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0 mt-0.5">
                <i className="ri-search-eye-line text-sm"></i>
              </div>
              <p>
                Users should always <strong className="text-foreground-900">verify product information</strong> 
                before purchasing. Our resources are for reference and research purposes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}